import React, {useState} from "react";
import Annotation from "react-image-annotation";
import { renderEditor } from "./CustomRenderers";

const AnnotationEditor = ({
  image,
  annotations,
  value,
  onChange,
  onSubmit,
  options
}) => {
  const [selectedValue, setSelectedValue] = useState("");

  if (!image) return null;

  return (
    <div className="annotation-editor mt-4">
      <h5 className="mb-3">Image Annotation</h5>
      <div style={{ maxWidth: "100%", position: "relative" }}>
        <Annotation
          src={image}
          alt="Annotation canvas"
          annotations={annotations}
          value={value}
          onChange={onChange}
          onSubmit={onSubmit}
          allowTouch
          renderEditor={(props) =>
            renderEditor({
              ...props,
              selectedValue,
              setSelectedValue,
              options,
            })
          }
        />
      </div>
    </div>
  );
};

export default AnnotationEditor;
